export const setClassnameOnActive = (className: string, matchQuery: boolean = false) => ({
  location,
  href,
}: {
  location: Location;
  href: string;
}) => {
  const matched = matchQuery ? location.pathname + location.search === href : location.pathname === href.split('?')[0];

  return matched ? { className } : {};
};

const DEFAULT_CHILD_NO_TAB_SELECTOR =
  'div[aria-hidden=true] a, div[aria-hidden=true] button:not([data-type="router-button"])';

export const setTabIndexForChildElements = (
  parentElementRef: string,
  childNoTabElementRef: string = DEFAULT_CHILD_NO_TAB_SELECTOR,
): void => {
  if (document.querySelectorAll) {
    const containers = document.querySelectorAll(parentElementRef);
    const childTabElementRef = childNoTabElementRef.replace(/aria-hidden=true/g, 'aria-hidden=false');
    Array.from(containers).forEach((container: any) => {
      const noTabLinks = container.querySelectorAll(childNoTabElementRef);
      Array.from(noTabLinks).forEach((link: any) => {
        link.setAttribute('tabindex', '-1');
      });
      const tabLinks = container.querySelectorAll(childTabElementRef);
      Array.from(tabLinks).forEach((link: any) => {
        link.removeAttribute('tabindex');
      });
    });
  }
};
